import { ActionType, EntityType, ModuleType } from "../../queryKeyFactory";

export const paymentsKeyFactory = {
  // ================================
  // PAYMENTS LIST
  // ================================
  list: (filters?: any): [ModuleType, EntityType, ActionType, any?] => [
    "cx",
    "payment",
    "list",
    filters,
  ],
  exportList: (filters?: any): [ModuleType, EntityType, ActionType, any?] => [
    "cx",
    "payment",
    "paymentExport",
    filters,
  ],
  // ================================
  // PAYMENT DETAILS
  // ================================
  details: (
    paymentId: number,
  ): [ModuleType, EntityType, ActionType, number] => [
    "cx",
    "payment",
    "details",
    paymentId,
  ],
  creditNoteDetails: (
    creditNoteId: number,
  ): [ModuleType, EntityType, ActionType, number] => [
    "cx",
    "creditNote",
    "details",
    creditNoteId,
  ],
  summary: (
    remoteUtilityId: number,
  ): [ModuleType, EntityType, ActionType, number] => [
    "cx",
    "payment",
    "summary",
    remoteUtilityId,
  ],
  userNames: (
    remoteUtilityId: number,
  ): [ModuleType, EntityType, ActionType, number] => [
    "cx",
    "payment",
    "userNames" as any,
    remoteUtilityId,
  ],
  // ================================
  // PAYMENT SERVICES
  // ================================
  services: (filters?: any): [ModuleType, EntityType, ActionType, any?] => [
    "cx",
    "payment",
    "services",
    filters,
  ],
  consumerSearch: (
    filters?: any,
  ): [ModuleType, EntityType, ActionType, any?] => [
    "cx",
    "payment",
    "consumerSearch",
    filters,
  ],
  consumerMetaData: (
    consumerId: number,
    remoteUtilityId: number,
  ): [ModuleType, EntityType, ActionType, number, number] => [
    "cx",
    "payment",
    "consumerMetaData",
    consumerId,
    remoteUtilityId,
  ],
  creditNoteSummary: (
    remoteUtilityId: number,
  ): [ModuleType, EntityType, ActionType, number] => [
    "cx",
    "creditNote",
    "summary",
    remoteUtilityId,
  ],
  latestBill: (
    remoteUtilityId: number,
    consumerId: number,
    consumerNo: string,
  ): [ModuleType, EntityType, ActionType, number, number, string] => [
    "cx",
    "payment",
    "latestBill",
    remoteUtilityId,
    consumerId,
    consumerNo,
  ],
  pendingBills: (
    remoteUtilityId: number,
    consumerId: number,
  ): [ModuleType, EntityType, string, number, number] => [
    "cx",
    "payment",
    "pendingBills",
    remoteUtilityId,
    consumerId,
  ],
  creditNotes: (filters?: any): [ModuleType, EntityType, ActionType, any?] => [
    "cx",
    "creditNote",
    "list",
    filters,
  ],
  createCreditNote: (
    remoteUtilityId: number,
    consumer: number,
    consumerNo: string,
  ): [ModuleType, EntityType, ActionType, number, number, string] => [
    "cx",
    "creditNote",
    "create",
    remoteUtilityId,
    consumer,
    consumerNo,
  ],
  creditNoteReasons: (
    remoteUtilityId: number,
  ): [ModuleType, EntityType, ActionType, number] => [
    "cx",
    "creditNote",
    "reasons",
    remoteUtilityId,
  ],
  paymentReceivedStatusChoices: (
    remoteUtilityId: number,
  ): [ModuleType, EntityType, ActionType, number] => [
    "cx",
    "payment",
    "receivedStatusChoices",
    remoteUtilityId,
  ],
  paymentPayTypeChoices: (
    remoteUtilityId: number,
  ): [ModuleType, EntityType, ActionType, number] => [
    "cx",
    "payment",
    "payTypeChoices",
    remoteUtilityId,
  ],
  installments: (params: {
    remoteUtilityId: number;
    consumerId: number;
    consumerNo: string;
  }): [ModuleType, EntityType, ActionType, any?] => [
    "cx",
    "payment",
    "installments",
    params,
  ],

  serviceOrderData: (params: {
    remote_utility_id: any;
    consumer_id: any;
  }): [ModuleType, EntityType, "serviceOrderData", any?] => [
    "cx",
    "payment",
    "serviceOrderData",
    params,
  ],
  paymentMethod: (params: {
    remoteUtilityId: number;
  }): [ModuleType, EntityType, ActionType, any?] => [
    "cx",
    "payment",
    "paymentMethod",
    params,
  ],
  paymentChannelChoices: (
    remoteUtilityId: number,
  ): [ModuleType, EntityType, ActionType, any?] => [
    "cx",
    "payment",
    "paymentChannel",
    remoteUtilityId,
  ],
  bulkPaymentBatches: (
    filters?: any,
  ): [ModuleType, EntityType, string, any?] => [
    "cx",
    "payment",
    "bulkPaymentBatches",
    filters,
  ],
  bulkPaymentBatchPreview: (
    id: number,
  ): [ModuleType, EntityType, string, number] => [
    "cx",
    "payment",
    "bulkPaymentBatchPreview",
    id,
  ],
  bulkPaymentBatchDetails: (
    id: number,
  ): [ModuleType, EntityType, string, number] => [
    "cx",
    "payment",
    "bulkPaymentBatchDetails",
    id,
  ],
  bulkPaymentBatchRecords: (
    filters: any,
  ): [ModuleType, EntityType, string, any] => [
    "cx",
    "payment",
    "bulkPaymentBatchRecords",
    filters,
  ],
  cheques: (filters?: any): [ModuleType, EntityType, string, any?] => [
    "cx",
    "payment",
    "cheques",
    filters,
  ],
  chequesKpi: (
    remoteUtilityId: number,
  ): [ModuleType, EntityType, string, number] => [
    "cx",
    "payment",
    "chequesKpi",
    remoteUtilityId,
  ],
  chequeDetails: (
    chequeId: number,
    remoteUtilityId: number,
  ): [ModuleType, EntityType, string, number, number] => [
    "cx",
    "payment",
    "chequeDetails",
    chequeId,
    remoteUtilityId,
  ],
  banks: (
    remoteUtilityId?: number,
  ): [ModuleType, EntityType, string, number?] => [
    "cx",
    "payment",
    "banks",
    remoteUtilityId,
  ],
  choices: (choice: string): [ModuleType, EntityType, string, string] => [
    "cx",
    "payment",
    "choices",
    choice,
  ],
  reconciliations: (filters?: any): [ModuleType, EntityType, string, any?] => [
    "cx",
    "payment",
    "reconciliations",
    filters,
  ],
  slipLots: (filters?: any): [ModuleType, EntityType, string, any?] => [
    "cx",
    "payment",
    "slipLots",
    filters,
  ],
  slipLotDetails: (
    id: number | string,
  ): [ModuleType, EntityType, string, any?] => [
    "cx",
    "payment",
    "slipLotDetails",
    { id },
  ],
  slipLotEntries: (filters?: any): [ModuleType, EntityType, string, any?] => [
    "cx",
    "payment",
    "slipLotEntries",
    filters,
  ],
  slipLotRecentScans: (
    lotId: number | string,
  ): [ModuleType, EntityType, string, any?] => [
    "cx",
    "payment",
    "slipLotRecentScans",
    { lotId },
  ],
  paymentMode: (
    remoteUtilityId: any,
  ): [ModuleType, EntityType, ActionType, any] => [
    "cx",
    "payment",
    "paymentMode",
    remoteUtilityId,
  ],
  consumerSearchForBillData: (
    filters?: any,
  ): [ModuleType, EntityType, ActionType, any?] => [
    "cx",
    "payment",
    "consumerSearchForBillData",
    filters,
  ],
  reconciliationSummary: (
    id: number | string,
  ): [ModuleType, EntityType, string, any] => [
    "cx",
    "payment",
    "reconciliationSummary",
    { id },
  ],
  reconciliationExport: (
    id: number | string,
  ): [ModuleType, EntityType, string, any] => [
    "cx",
    "payment",
    "reconciliationExport",
    { id },
  ],
  reconciliationSystemReceipts: (
    filters?: any,
  ): [ModuleType, EntityType, string, any?] => [
    "cx",
    "payment",
    "reconciliationSystemReceipts",
    filters,
  ],
  reconciliationDrillDown: (
    id: number | string,
    channelId: number | string,
    page?: number,
    limit?: number,
    search?: string,
  ): [ModuleType, EntityType, string, any] => [
    "cx",
    "payment",
    "reconciliationDrillDown",
    { id, channelId, page, limit, search },
  ],
  reconciliationById: (
    id: number | string,
    remoteUtilityId: number | string,
  ): [ModuleType, EntityType, string, any] => [
    "cx",
    "payment",
    "reconciliationById",
    { id, remoteUtilityId },
  ],
  activityLogs: (filters: any): [ModuleType, EntityType, string, any] => [
    "cx",
    "payment",
    "activityLogs",
    filters,
  ],
  checkTransferPayment: (
    paymentId: number,
    remoteUtilityId: number,
  ): [ModuleType, EntityType, string, number, number] => [
    "cx",
    "payment",
    "checkTransferPayment",
    paymentId,
    remoteUtilityId,
  ],
  checkRefundPayment: (
    paymentId: number,
    remoteUtilityId: number,
  ): [ModuleType, EntityType, string, number, number] => [
    "cx",
    "payment",
    "checkRefundPayment",
    paymentId,
    remoteUtilityId,
  ],
  transferConsumerSearch: (
    filters?: any,
  ): [ModuleType, EntityType, string, any?] => [
    "cx",
    "payment",
    "transferConsumerSearch",
    filters,
  ],
  paymentChoices: (
    choiceType: string,
  ): [ModuleType, EntityType, string, string] => [
    "cx",
    "payment",
    "paymentChoices",
    choiceType,
  ],
};
